import React, { useState, useEffect } from "react";
import { Card, Table, Avatar, Tag, Space, message } from "antd";
import GainModal from "../../components/objects/GainModal";

import CardTitleFilter from "../../components/objects/CardTitle";

import AddUser from "./Add";

import { getUsers, deleteUser } from "../../services/api";
import { baseURL } from "../../config";

import EditButton from "../../components/objects/EditButton";
import DeleteButton from "../../components/objects/DeleteButton";

import _ from "lodash";

import { Search, Sort, MomentFormat } from "../../tools";

export default function User() {
  const [ModalVisible, setModalVisible] = useState(false);
  const [data, setData] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  // const [dataSearch, setDataSearch] = useState([]);
  const [dataEdit, setDataEdit] = useState(false);
  const [Loading, setLoading] = useState(false);

  const [value, setValue] = useState("");

  useEffect(() => {
    userLists();
  }, []);

  const userLists = async () => {
    setLoading(true);
    const res = await getUsers();
    if (res.status === 200) {
      setData(res.data.data);
      setDataSource(res.data.data);
      setLoading(false);
    }
  };

  const onUpdate = (e) => {
    const res = dataSource.filter((item) => item.id === e);
    setModalVisible(true);
    setDataEdit(...res);
  };

  const onDelete = async (e) => {
    const res = await deleteUser(e);
    if (res.status === 200) {
      message.success("Deleted");
      userLists();
    } else {
      message.error("Delete Failed");
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "firstname",
      key: "id",
      render: (text, record, index) => (
        <div className="flex items-center">
          <Avatar
            size={45}
            src={`${baseURL}/api/images/${record.profile}`}
            style={{ backgroundColor: "#4660f1" }}
          >
            {!record.profile && record.firstname.charAt(0).toUpperCase()}
          </Avatar>
          <span className="pl-5">{record.firstname}</span>
          <span className="pl-5">{record.lastname}</span>
        </div>
      ),
    },
    {
      title: "ID",
      dataIndex: "ID",
      key: "ID",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (text) =>
        text ? (
          <Tag className="bg-green-50 text-green-500 border-none font-light rounded-md px-3 py-1">
            Active
          </Tag>
        ) : (
          <Tag className="bg-red-50 text-red-500 border-none font-light rounded-md px-3 py-1">
            Offline
          </Tag>
        ),
    },
    {
      title: "Year",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => MomentFormat(text),
    },
    {
      title: "",
      dataIndex: "id",
      key: "id",
      render: (text) => (
        <Space>
          <EditButton onClick={() => onUpdate(text)} />
          <DeleteButton onClick={() => onDelete(text)} />
        </Space>
      ),
    },
  ];

  const onPagination = (e) => {
    console.log(e);
  };

  const pagiOptions = {
    total: dataSource?.length,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    onChange: onPagination,
  };

  return (
    <div>
      <h1 className="text-3xl font-bold">User Management</h1>
      <Card
        title={
          <CardTitleFilter
            filterOptions={columns}
            addLabel="Add User"
            onAdd={() => {
              setModalVisible(true);
              setDataEdit(false);
            }}
            onSearch={(keyword) => {
              const dataSearch = Search(data, keyword);
              setDataSource(dataSearch);
            }}
            onSort={(dataIndex) => {
              const dataSort = Sort(data, dataIndex);
              setDataSource(dataSort);
            }}
          />
        }
        className="border-none rounded-lg rounded-b-none"
      >
        <Table
          dataSource={dataSource}
          columns={columns}
          pagination={pagiOptions}
          loading={Loading}
        />
      </Card>
      <GainModal
        title={dataEdit ? "Edit User" : "Add User"}
        visible={ModalVisible}
        onClose={() => setModalVisible(false)}
      >
        <AddUser
          onFinish={() => {
            setModalVisible(false);
            userLists();
          }}
          dataEdit={dataEdit}
        />
      </GainModal>
    </div>
  );
}
